import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  position: relative;
  color: #5b6e88;
`

export const MainContainer = styled.section`
  margin: 5.625rem 1.125rem 1.125rem 16.5625rem;
  background: white;
  width: 100%;
`

export const ChartContainer = styled.div`
  height: 100%;
  #charts_ChartTitle {
    font-size: 1.4375rem !important;
    font-family: 'Source Sans Pro', sans-serif !important;
    font-weight: 600 !important;
  }
`